const P = ({ className }) => (
  <div className={`animate-pulse bg-gray-100 rounded-lg ${className}`} />
);

const SkeletonDashboard = () => (
  <div className="space-y-4">
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {[...Array(4)].map((_, i) => <P key={i} className="h-20 rounded-xl" />)}
    </div>
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {[...Array(4)].map((_, i) => <P key={i} className="h-20 rounded-xl" />)}
    </div>
    <P className="h-24 rounded-xl" />
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <P className="h-72 rounded-xl" />
      <P className="h-72 rounded-xl" />
    </div>
    <P className="h-48 rounded-xl" />
  </div>
);

export default SkeletonDashboard;
